import React from 'react';
import { Link } from 'react-router-dom';
import useLanguage from '../../hooks/useLanguage';
import productsData from '../../data/products.json';
import translationsData from '../../data/translations.json';
import Card from '../common/Card';
import Button from '../common/Button';

const FeaturedProducts = () => {
  const { language } = useLanguage();

  // Get first 3 products
  const featuredProducts = productsData.products.slice(0, 3);

  const sectionTitle = language === 'ko' ? translationsData.titles.featuredProducts : translationsData.titles.featuredProductsEn;
  const viewAllBtn = language === 'ko' ? translationsData.buttons.viewProducts : translationsData.buttons.viewProductsEn;

  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Section Title */}
        <div className="text-center mb-12" data-aos="fade-up">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            {sectionTitle}
          </h2>
          <div className="w-24 h-1 bg-blue-600 mx-auto"></div>
        </div>

        {/* Products Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {featuredProducts.map((product, index) => (
            <Link
              key={product.id}
              to={`/products/${product.id}`}
              className="block h-full"
              data-aos="fade-up"
              data-aos-delay={index * 100}
            >
              <Card className="h-full flex flex-col hover:shadow-2xl transition-all duration-300">
                {/* Product Image */}
                <div className="relative w-full h-48 md:h-56 overflow-hidden rounded-t-lg">
                  <img
                    src={product.image}
                    alt={language === 'ko' ? product.name : product.nameEn}
                    className="w-full h-full object-cover"
                  />
                  {/* Category Badge */}
                  <div className="absolute top-4 left-4 bg-blue-600 text-white px-3 py-1 rounded-full text-sm font-semibold">
                    {language === 'ko' ? product.category : product.categoryEn}
                  </div>
                </div>

                {/* Product Info */}
                <div className="p-6 flex-1 flex flex-col">
                  <h3 className="text-xl font-semibold text-gray-900 mb-3">
                    {language === 'ko' ? product.name : product.nameEn}
                  </h3>
                  <p className="text-gray-600 line-clamp-2 flex-1">
                    {language === 'ko' ? product.shortDescription : product.shortDescriptionEn}
                  </p>
                </div>
              </Card>
            </Link>
          ))}
        </div>

        {/* View All Button */}
        <div className="text-center">
          <Link to="/products">
            <Button variant="primary" size="lg" className="px-8 py-3">
              {viewAllBtn}
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FeaturedProducts;
